import { useNavigate } from "react-router-dom";
import { Button, Layout } from "antd";

export default function PageHome() {
	const navigate = useNavigate();

	return (
		<Layout.Content>
			<video
				src="/assets/Joya_Life_video_background.mp4"
				autoPlay
				muted
				loop
				playsInline
			>
				Your browser does not support the video tag.
			</video>
			<div className="main-content">
				<div className="logo-wrapper">
					<img
						src="/assets/joyalifevertical_green_on_white_transparent.png"
						alt="joyalifevertical_green_on_white_transparent.png"
					/>
				</div>

				<div className="content-title">
					Build your best life and take our Happiness score now.
				</div>

				<Button type="primary" onClick={() => navigate("/scorecard")}>
					START SCORECARD
				</Button>
			</div>
		</Layout.Content>
	);
}
